import { CaretDownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { ReactNode } from 'react';

export interface IProps {
  children: ReactNode;
  bgColor?: string;
  items?: MenuProps['items'];
  borderRadius?: string;
  size?: 'sm' | 'md';
  type?: 'submit' | 'button';
  onClick?: () => void;
  disabled?: boolean;
  color?: string;
  border?: string;
  customClass?: string;
}

export default function Button(props: IProps): JSX.Element {
  const {
    items,
    children,
    bgColor = 'bg-primary-50',
    borderRadius = 'lg',
    size = 'sm',
    type = 'button',
    onClick,
    disabled = false,
    color = 'text-white',
    border = 'border-white',
    customClass = '',
  } = props;

  const padding = size === 'sm' ? 'py-3 px-6' : 'py-4 px-20';
  const opacity = disabled ? '20' : '100';

  return (
    <button
      type={type}
      className={`flex ${bgColor} items-center opacity-${opacity} rounded-${borderRadius} ${color} para-bold-1 border border-solid ${border} ${customClass}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={`flex gap-3 ${padding} border-r border-solid ${border}`}>
        {children}
      </div>
      <Dropdown
        disabled={disabled}
        menu={{ items }}
        className="custom-dropdown-btn"
        // trigger={['click']}
        placement="bottomRight"
        arrow
      >
        <div className="flex py-3 px-3">
          <CaretDownOutlined />
        </div>
      </Dropdown>
    </button>
  );
}
